"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _team.default;
  }
});
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
require("@webex/internal-plugin-conversation");
require("@webex/internal-plugin-user");
require("@webex/internal-plugin-encryption");
var _webexCore = require("@webex/webex-core");
var _team = _interopRequireDefault(require("./team"));
var _config = _interopRequireDefault(require("./config"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

(0, _webexCore.registerInternalPlugin)('team', _team.default, {
  payloadTransformer: {
    predicates: [{
      name: 'decryptTeamRoomStatus',
      direction: 'inbound',
      test: function test(ctx, optionsOrResponse) {
        return _promise.default.resolve((0, _has2.default)(optionsOrResponse, 'activity.object.activityEvent') && (0, _get2.default)(optionsOrResponse, 'activity.object.objectType') === 'teamRoomStatus');
      },
      extract: function extract(optionsOrResponse) {
        return _promise.default.resolve(optionsOrResponse.activity.object);
      }
    }],
    transforms: [{
      name: 'decryptTeam',
      direction: 'inbound',
      fn: function fn(ctx, key, team) {
        var promises = [];
        if (team.conversations.items) {
          promises.push(_promise.default.all(team.conversations.items.map(function (item) {
            return ctx.transform('decryptObject', null, item);
          })));
        }
        var usableKey = team.encryptionKeyUrl || key;
        if (usableKey) {
          promises.push(ctx.transform('decryptPropDisplayName', usableKey, team));
          promises.push(ctx.transform('decryptPropSummary', usableKey, team));
        }
        return _promise.default.all(promises);
      }
    }, {
      name: 'decryptTeamRoomStatus',
      direction: 'inbound',
      fn: function fn(ctx, teamRoomStatus) {
        var keyUrl = (0, _get2.default)(teamRoomStatus, 'activityEvent.encryptionKeyUrl');
        return ctx.transform('decryptObject', keyUrl, teamRoomStatus.activityEvent);
      }
    }, {
      name: 'decryptPropSummary',
      direction: 'inbound',
      fn: function fn(ctx, key, team) {
        return ctx.transform('decryptTextProp', 'summary', key, team);
      }
    }, {
      name: 'encryptTeam',
      direction: 'outbound',
      fn: function fn(ctx, key, team) {
        if (key === false) {
          return _promise.default.resolve();
        }
        return _promise.default.resolve(key || ctx.webex.internal.encryption.kms.createUnboundKeys({
          count: 1
        })).then(function (keys) {
          var k = (0, _isArray2.default)(keys) ? keys[0] : keys;
          if (team.kmsMessage && team.kmsMessage.keyUris && !team.kmsMessage.keyUris.includes(k.uri)) {
            team.kmsMessage.keyUris.push(k.uri);
          }
          return _promise.default.all([ctx.transform('encryptPropDisplayName', k, team), ctx.transform('encryptPropSummary', k, team)]).then(function () {
            team.encryptionKeyUrl = k.uri || k;

            // we only want to set the defaultActivityEncryptionKeyUrl if we've
            // bound a new key
            if (!key) {
              team.defaultActivityEncryptionKeyUrl = team.defaultActivityEncryptionKeyUrl || k.uri || k;
            }
          });
        });
      }
    }, {
      name: 'encryptPropSummary',
      direction: 'outbound',
      fn: function fn(ctx, key, team) {
        return ctx.transform('encryptTextProp', 'summary', key, team);
      }
    }, {
      name: 'normalizeTeam',
      fn: function fn(ctx, team) {
        team.conversations = team.conversations || {};
        team.conversations.items = team.conversations.items || [];
        team.teamMembers = team.teamMembers || {};
        team.teamMembers.items = team.teamMembers.items || [];
        return _promise.default.all([_promise.default.all(team.conversations.items.map(function (item) {
          return ctx.transform('normalizeObject', item);
        })), _promise.default.all(team.teamMembers.items.map(function (item) {
          return ctx.transform('normalizeObject', item);
        }))]);
      }
    }]
  },
  config: _config.default
});
//# sourceMappingURL=index.js.map
